module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "page-description",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          You will be redirected to the login page. If not, please click "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("here")]), _vm._v(".\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-wrapper",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.fos_user_resetting_form.plainPassword.first !== '' || _vm.passwordFocus,
      'has-error': this.errors.has('Password')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-reset-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('password')
      }
    }
  }), _vm._v(" "), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "Password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formInfo.fos_user_resetting_form.plainPassword.first) ? _vm._i(_vm.formInfo.fos_user_resetting_form.plainPassword.first, null) > -1 : (_vm.formInfo.fos_user_resetting_form.plainPassword.first)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.formInfo.fos_user_resetting_form.plainPassword.first,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $$c)
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "Password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formInfo.fos_user_resetting_form.plainPassword.first, null)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.first),
      expression: "formInfo.fos_user_resetting_form.plainPassword.first"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-reset-password",
      "data-lpignore": "true",
      "name": "Password",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.formInfo.fos_user_resetting_form.plainPassword.first)
    },
    on: {
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "first", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Password')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.fos_user_resetting_form.plainPassword.second !== '' || _vm.retypePasswordFocus,
      'has-error': this.errors.has('Retype password')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password-retype"
    }
  }, [_vm._v("Retype password")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('retypePassword')
      }
    }
  }), _vm._v(" "), ((_vm.retypePasswordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:Password'),
      expression: "'required|confirmed:Password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formInfo.fos_user_resetting_form.plainPassword.second) ? _vm._i(_vm.formInfo.fos_user_resetting_form.plainPassword.second, null) > -1 : (_vm.formInfo.fos_user_resetting_form.plainPassword.second)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.formInfo.fos_user_resetting_form.plainPassword.second,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $$c)
        }
      }
    }
  }) : ((_vm.retypePasswordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:Password'),
      expression: "'required|confirmed:Password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formInfo.fos_user_resetting_form.plainPassword.second, null)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:Password'),
      expression: "'required|confirmed:Password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.fos_user_resetting_form.plainPassword.second),
      expression: "formInfo.fos_user_resetting_form.plainPassword.second"
    }],
    staticClass: "landing-page-login-password",
    attrs: {
      "id": "landing-page-login-password-retype",
      "data-lpignore": "true",
      "name": "Retype password",
      "type": _vm.retypePasswordType
    },
    domProps: {
      "value": (_vm.formInfo.fos_user_resetting_form.plainPassword.second)
    },
    on: {
      "focus": function($event) {
        _vm.retypePasswordFocus = true
      },
      "blur": function($event) {
        _vm.retypePasswordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.fos_user_resetting_form.plainPassword, "second", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Retype password')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Retype password')))]) : _vm._e()]), _vm._v(" "), (_vm.loginForm.isError) ? _c('div', {
    staticClass: "login-form-error"
  }, [_vm._v("\n            " + _vm._s(_vm.loginForm.loginErrorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.resetInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetPassword()
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.formStatus.shown) ? _c('div', {
    staticClass: "form-message",
    class: _vm.formStatus.success ? 'success' : 'error'
  }, [(_vm.formStatus.title !== '') ? _c('h1', [_vm._v(_vm._s(_vm.formStatus.title))]) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v(_vm._s(_vm.formStatus.body))]) : _vm._e()]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "content text-left"
  }, [_vm._v("\n            We're almost there.\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-beafd36e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/ActivateAccount.vue
// module id = 1051
// module chunks = 0